import React, { FC } from 'react'
import { Box, Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { GreenButton } from '../../components/Buttons/GreenButton'
import { routes } from '../../constants/routes'
import video from '../../images/home/home.mp4'

const useStyles = makeStyles((theme: Theme) => ({
  main: {
    width: '100%',
    minHeight: 'calc(100vh - 248px)',
    paddingTop: 176,
  },
  animationBack: {
    position: 'fixed',
    top: 0,
    minHeight: '100%',
    background: theme.palette.info.light,
  },
  animation: {
    position: 'fixed',
    zIndex: 0,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    opacity: '50%',
    objectFit: 'cover',
  },
  animationAbove: {
    position: 'fixed',
    minHeight: '100%',
    background: '#0B0097',
    opacity: '60%',
  },
  container: {
    maxWidth: 1184,
    margin: '0 auto',
    position: 'relative',
    zIndex: 100,
    borderTop: '1px solid rgba(255, 255, 255, 0.322)',
  },
  homeBox: {
    width: 480,
  },
  title: {
    marginTop: 128,
    fontSize: 48,
    color: theme.palette.primary.light,
  },
}))

export const Home: FC = () => {
  const classes = useStyles()
  return (
    <main className={classes.main}>
      <Grid container className={classes.animationBack}>
        <video id="background-video" loop autoPlay muted className={classes.animation}>
          <source src={video} type="video/mp4" />
          <source src={video} type="video/ogg" />
          Your browser does not support the video tag.
        </video>
        <Grid container className={classes.animationAbove} />
      </Grid>

      <Grid item lg className={classes.container}>
        <Box className={classes.homeBox}>
          <Typography className={classes.title} variant="h1" gutterBottom>
            A New Generation of Fintech
          </Typography>

          <GreenButton width={460} mt={50} mb={269} href={routes.CONTACT} text={'Contact us'} />
        </Box>
      </Grid>
    </main>
  )
}
